import React, { Component } from "react";
import "./Certifications.css";
import { Fade } from "react-reveal";
import { certifications } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";
import { withTranslation } from 'react-i18next';

class Certifications extends Component {
  render() {
    const theme = this.props.theme;
    const { t } = this.props;
    return (
      <div className="main" id="certs">
        <div className="certs-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="certs-header" style={{ color: theme.text }}>
              {t('certifications.header')}
            </h1>
          </Fade>
        </div>
        <div className="certs-body-div">
          {certifications.certifications.map((cert, index) => {
            return <CertificationCard certificate={cert} certIndex={index} theme={theme} key={index} />;
          })}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Certifications);
